/**
 *订单相关API
 */
import request from '../setup/request';
import { base64 } from '../setup/common';
const order = {
  /**
   * 获取商户所有支付配置API  //个人用户关联商户用户
   * http://124.127.40.85:8888/platform/user2.0/auth/relateMerchant
   * @param params
   *
   */
  relateMerchant(params) {
    return request.post(
      '',
      Object.assign(params, {
        method: 'ih.user.auth.relateMerchant',
      }),
    );
  },
  /**
   * 下单
   * http://124.127.40.85:8888/res-platform/xding/order/submit
   *
   */
  orderSubmit(params) {
    return request.post(
      '',
      Object.assign(params, {
        method: 'ih.cticket.order.submit',
        user_ticket_info: base64(JSON.stringify(params.user_ticket_info)),
      }),
    );
  },
  /**
   * 订单详情
   *
   */
  orderDetail(params) {
    return request.post(
      '',
      Object.assign(params, {
        method: 'ih.cticket.order.getDetailEx',
      }),
    );
  },
  /**
   * 取消订单
   *
   */
  orderCancel(params) {
    return request.post(
      '',
      Object.assign(params, {
        method: 'ih.cticket.order.cancel',
      }),
    );
  },
  /**
   * 获取订单列表
   *
   */
  orderList(params) {
    return request.post(
      '',
      Object.assign(params, {
        method: 'ih.cticket.user.getOrdersEx',
      }),
    );
  },
  /**
   * 退单
   *
   */
  orderRefund(params) {
    return request.post(
      '',
      Object.assign(params, {
        method: 'ih.cticket.user.orderRefund',
      }),
    );
  },
  /**
   * 支付
   *
   */
  orderPaySubmit(params) {
    console.log('支付参数', JSON.stringify(params));
    return request.post(
      '',
      Object.assign(params, {
        method: 'ih.boss.pay.submit',
      }),
    );
  },
  /**
   * 0元票接口
   *
   */
  payOrderZero(params) {
    return request.post(
      '',
      Object.assign(params, {
        method: 'ih.cticket.ticketoffice.pay',
      }),
    );
  },
  /**
   * 查询用户已购的票
   *
   */
  userGetTickets(params) {
    return request.post(
      '',
      Object.assign(params, {
        method: 'ih.cticket.user.getTickets',
      }),
    );
  },
};

export default order;
